class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (this.swiper) return; // prevent multiple init
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.reviewsslider');
    const pagination = this.querySelector('.swiper-pagination');

    if (!slider) return;

    this.swiper = new Swiper(slider, {
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true, // mobile jump fix
      loop: true,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      pagination: {
        el: pagination,
        clickable: true,
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('review-slider', ReviewSlider);


/* landing review slider */
class LandReviewSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initSwiper();
  }
  initSwiper() {
    const swiperEl = this.querySelector('.land-reviews-slider');

    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      spaceBetween: 15,
      slidesPerView: 1.2,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 4
        }
      }
    });
  }
}
customElements.define('land-reviews-slider', LandReviewSlider);
